import { CPLAT_API_ROUTES, useFetch, usePost } from '@/api';
import { useUpdateAccountDialog } from '@/contexts/UpdateAccountDialogContext';
import { useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';

export const useCheckAccountType = () => {
  const [localStorageCplatToken] = useLocalStorage('cplatToken', '');
  const [IsEmailRegistered, setIsEmailRegistered] = useState(true);

  const { openUpdateAccountDialog } = useUpdateAccountDialog();
  const { mutate: getUserInfo } = usePost(CPLAT_API_ROUTES.getInfo, undefined, undefined, true);

  useEffect(() => {
    if (localStorageCplatToken)
      getUserInfo(
        { cplatToken: localStorageCplatToken },
        {
          onSuccess: (response) => {
            if (!response.data.data[0].accountEmail) {
              // 이메일 계정이 아닌 경우 → 모달 오픈
              openUpdateAccountDialog();
              setIsEmailRegistered(false);
            }
          },
        },
      );
  }, [localStorageCplatToken, openUpdateAccountDialog]);

  return IsEmailRegistered;
};
